var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1491 4.72566V7.21419H0V4.72566C0 3.36155 1.1161 2.2454 2.48026 2.2454H5.37389V4.69261C5.37389 5.14731 5.74594 5.51936 6.20064 5.51936C6.65534 5.51936 7.02739 5.14731 7.02739 4.69261V2.2454H16.1217V4.69261C16.1217 5.14731 16.4937 5.51936 16.9484 5.51936C17.4031 5.51936 17.7752 5.14731 17.7752 4.69261V2.2454H20.6688C22.033 2.2454 23.1491 3.36155 23.1491 4.72566Z",
    fill: "#0E94CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.535 17.1435H22.6448L15.7083 23.3276V17.9702C15.7083 17.5155 16.0803 17.1435 16.535 17.1435Z",
    fill: "#0E94CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1491 8.86769V15.49H16.535C15.1709 15.49 14.0548 16.6061 14.0548 17.9702V23.7741H2.48026C1.1161 23.7741 0 22.6579 0 21.2938V8.86769H23.1491Z",
    fill: "#0E94CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02739 1.45175V2.2454H5.37389V1.45175C5.37389 0.997049 5.74594 0.625 6.20064 0.625C6.65534 0.625 7.02739 0.997049 7.02739 1.45175Z",
    fill: "#0E94CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7752 1.45175V2.2454H16.1217V1.45175C16.1217 0.997049 16.4937 0.625 16.9484 0.625C17.4031 0.625 17.7752 0.997049 17.7752 1.45175Z",
    fill: "#0E94CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.df69bb556e28f00e53bb7ac80e487483.svg";
export { ForwardRef as ReactComponent };